/*字典 */
import { $http, buildHeaders } from "./index";

//获取数据字典类别列表
export const dictionary_cate_list = () => {
  return $http.get("/admin/DictionaryCate/index", {
    params: {
      limit: 0,
      status: 1,
    },
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取数据字典类别列表
export const dictionary_tree = (dictionary_cate_id) => {
  return $http.get("/admin/Dictionary/index", {
    params: {
      dictionary_cate_id,
      limit: 0,
      status: 1,
    },
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取列表
export const dictionary_page = (params) => {
  return $http.get("/admin/Dictionary/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const dictionary_detail = (id) => {
  return $http.get("/admin/Dictionary/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const dictionary_add = (data) => {
  return $http.post("/admin/Dictionary/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const dictionary_edit = (data) => {
  return $http.post("/admin/Dictionary/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const dictionary_delete = (id) => {
  return $http.post(
    "/admin/Dictionary/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//修改状态
export const dictionary_updateStatus = (data) => {
  return $http.post("/admin/Dictionary/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
